import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-4 md:py-6 px-4 bg-[#F7F5F0] text-center" data-id="element-65">
      <div className="max-w-2xl mx-auto" data-id="element-66">
        <div className="bg-white p-4 md:p-5 border border-black/10 rounded-2xl shadow-sm" data-id="element-67">
          <CTAButton large className="mb-3 md:mb-4" data-id="element-68">
            QUIERO MI SISTEMA 15D
          </CTAButton>
          <p className="text-sm md:text-lg font-bold text-text-primary italic tracking-tight" data-id="element-69">
            Cociná menos. Comé más saludable. Viví mejor.
          </p>
        </div>
      </div>
    </section>;
}